export default {
  UPDATE_SELECTED_CUSTOMER: 'HOME/UPDATE_SELECTED_CUSTOMER',
  UPDATE_ALL_CUSTOMER: 'HOME/UPDATE_ALL_CUSTOMER',
  UPDATE_ALL_CUSTOMER_GROUP: 'HOME/UPDATE_ALL_CUSTOMER_GROUP'
};
